export default __webpack_public_path__ + "static/media/011-tyrannosaurus rex.fb34ef4a.svg";